import React, { useEffect, useRef, useState } from 'react';

const VideoPlayer = ({ videoInfo, nextVideoInfo, requestNextVideo, onVideoEnd }) => {
    // We use two refs to swap between two video elements
    const videoRef1 = useRef(null);
    const videoRef2 = useRef(null);
    const [activePlayer, setActivePlayer] = useState(1); // 1 or 2
    const [isBuffering, setIsBuffering] = useState(false);
    const nextVideoRequested = useRef(false);

    // Handle the Current Video (Active Player)
    useEffect(() => {
        if (!videoInfo?.url) return;

        const currentPlayer = activePlayer === 1 ? videoRef1.current : videoRef2.current;
        
        console.log(`Current: ${videoInfo.filename}`);

        // Only update src if it's actually different to prevent restarts
        if (currentPlayer.src !== videoInfo.url) {
            currentPlayer.src = videoInfo.url;
            currentPlayer.muted = !videoInfo.speech;
            currentPlayer.play().catch(e => console.warn("Playback failed:", e));
        }
        
        nextVideoRequested.current = false;
    }, [videoInfo]);

    // Preload the Next Video in the hidden player
    useEffect(() => {
        if (!nextVideoInfo?.url) return;

        const hiddenPlayer = activePlayer === 1 ? videoRef2.current : videoRef1.current;
        console.log(`Pre-loading next: ${nextVideoInfo.filename}`);
        
        hiddenPlayer.src = nextVideoInfo.url;
        hiddenPlayer.preload = "auto";
        hiddenPlayer.muted = !nextVideoInfo.speech;
        hiddenPlayer.load(); // Start buffering in background
    }, [nextVideoInfo]);

    const handleTimeUpdate = (e) => {
        const timeLeft = e.target.duration - e.target.currentTime;
        // Trigger request for next video sooner (3-4 seconds before end)
        if (timeLeft <= 4 && !nextVideoRequested.current) {
            nextVideoRequested.current = true;
            requestNextVideo();
        }
    };

    const handleVideoEnded = () => {
        // Switch the active player state
        let nextIndex = activePlayer === 1 ? 2 : 1;
        const currentPlayer = nextIndex === 1 ? videoRef1.current : videoRef2.current;
        setIsBuffering(true);
        currentPlayer.play()
        .then(() => {
            console.log("Switched to next video.");
            setActivePlayer(nextIndex);
            setIsBuffering(false);
        }).catch(e => console.warn("Playback failed:", e));
        onVideoEnd();
    };

    const videoStyle = (isActive) => ({
        zIndex: isActive ? 2 : 1,
        filter: isBuffering ? 'blur(1px)' : 'blur(0px)',
        transition: 'filter 1s ease',
    });

    return (
        <div style={{ position: 'relative', width: '100%', height: '100%', overflow: 'hidden' }}>
            <video
                className="video-element"
                ref={videoRef1}
                style={videoStyle(activePlayer === 1)}
                playsInline
                muted={activePlayer !== 1} // Mute the background one
                onTimeUpdate={activePlayer === 1 ? handleTimeUpdate : null}
                onEnded={activePlayer === 1 ? handleVideoEnded : null}
                // controls
            />
            <video
                className="video-element"
                ref={videoRef2}
                style={videoStyle(activePlayer === 2)}
                playsInline
                muted={activePlayer !== 2} // Mute the background one
                onTimeUpdate={activePlayer === 2 ? handleTimeUpdate : null}
                onEnded={activePlayer === 2 ? handleVideoEnded : null}
                // controls
            />
        </div>
    );
};

export default VideoPlayer;